import React, { FC } from 'react';
import { isInactiveEntitlement } from '../../../util/subscribedAccessUtils';
import CustomTable from '../../General/Table/CustomTable';
import { isEditableSource } from '../../../util/utils';
import { descendingObjectComparator } from '../../../util/sortingUtils';
import { HeadCell } from '../../../types/table';
import { ClaimRowData, EntitlementRowData } from './entitlements-ui-types';
import { TooltipCellConfig } from '../../General/Table/table-ui-types';

interface ClaimsTableProps {
  data: EntitlementRowData;
  handleEdit?: (row: EntitlementRowData, index: number) => void;
  headCells: HeadCell<any>[];
  rowConfig: TooltipCellConfig<any>[];
}

const ClaimsTable: FC<ClaimsTableProps> = ({ data, handleEdit, headCells, rowConfig }) => {
  const customHandleEdit = (row: ClaimRowData, index: number) => {
    return handleEdit ? handleEdit(data, index) : undefined;
  };

  return (
    <>
      <CustomTable
        collection={data.claims}
        handleEditClick={
          isEditableSource(data.sourceId) && handleEdit ? customHandleEdit : undefined
        }
        headerCells={headCells}
        rowCellConfig={rowConfig}
        isHighlighted={(data: ClaimRowData) =>
          isInactiveEntitlement(data.isActive, data.validFrom, data.validTo)
        }
        isPaginated={false}
        isSortable={true}
        comparator={descendingObjectComparator}
      />
    </>
  );
};

export default ClaimsTable;
